




















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DraggableIcon from './DraggableIcon.vue';
import { clone } from '../../../../jbi-shared/util/group-level-attributes.util';
import {
  GroupLevelAttributeListType,
  GroupLevelAttributeValue
} from '@/jbi-shared/types/jaas-group-level-attributes.types';
import AttributeActionButtons from './AttributeActionButtons.vue';

@Component({
  components: {
    DraggableIcon,
    AttributeActionButtons
  }
})
export default class GroupLevelAttributeListField extends Vue {
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop() fieldClasses!: any;
  @Prop() duplicationError!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) overrideDisableDraggable!: boolean;
  @Prop({ default: false }) overrideDisableAttributeButton!: boolean;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;

  fieldErrorMsg: string = '';

  get listValue(): GroupLevelAttributeListType {
    return this.attributeValue.value as GroupLevelAttributeListType;
  }

  get listOption(): GroupLevelAttributeListType {
    return this.attributeValue.option as GroupLevelAttributeListType;
  }

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  assignValue(): void {
    this.attributeValue.value = this.listValue;
    this.attributeValue.value.options = (this.attributeValue
      .option as GroupLevelAttributeListType).options;
  }

  clearRadioButtonValue(element: any): void {
    const clickedValue: string = element.target.parentElement.children[0].value;

    if (clickedValue === this.listValue.selected) {
      this.listValue.selected = '';
    }
  }

  @Watch('isRequired', { immediate: true })
  updateErrorState() {
    const attributeValue = this.attributeValue
      .value as GroupLevelAttributeListType;
    const hasValues = attributeValue.isSingleSelection
      ? attributeValue.selected !== ''
      : (attributeValue.selected as string[]).some((value) => value !== '');

    if (hasValues) {
      this.validateRequiredFieldValues();
      return;
    }

    this.attributeValue.hasFieldError = this.isRequired;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('listValue', { deep: true })
  listOptionChangeCallback(): void {
    this.assignValue();
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('attributeValue.value', { deep: true })
  validateRequiredFieldValues(): void {
    if (!this.listOption) {
      this.fieldErrorMsg = 'The list is empty. Please provide some options.';
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    }
    /**
     * A required list must have:
     * 1. selections
     * 2. selected value(s)
     */
    if (this.isRequired) {
      if (
        (this.attributeValue.value as GroupLevelAttributeListType).options
          .length === 0
      ) {
        this.fieldErrorMsg = `${this.attributeValue.label} is required.`;
        this.attributeValue.hasFieldError = true;
        this.updateAttributeValue(this.attributeValue);
        return;
      }

      if (
        (this.attributeValue.value as GroupLevelAttributeListType).selected
          .length === 0
      ) {
        this.fieldErrorMsg = `${this.attributeValue.label} must have selected value(s).`;
        this.attributeValue.hasFieldError = true;
        this.updateAttributeValue(this.attributeValue);
        return;
      }
    }

    this.fieldErrorMsg = '';
    this.attributeValue.hasFieldError = false;
    this.updateAttributeValue(this.attributeValue);
  }
}
